import { z } from "zod";
import { Upload } from "@/lib/FileUpload/FileUploader";

export const incidentClaimShape = {
  excess_amount: z.number().int().min(1).nullable(),
  insurer: z.string().max(255).optional(),
  claim_reference: z.string().max(255).optional(),
  claim_documents: z.array(z.custom<Upload>()),
};

export function requireIncidentClaim(messages: {
  excessRequired: string;
  documentsRequired: string;
}) {
  return (
    values: {
      excess_amount: number | null;
      claim_documents: Upload[];
    },
    ctx: z.RefinementCtx,
  ) => {
    if (values.excess_amount === null) {
      ctx.addIssue({
        code: "custom",
        path: ["excess_amount"],
        message: messages.excessRequired,
      });
    }

    if (values.claim_documents.length === 0) {
      ctx.addIssue({
        code: "custom",
        path: ["claim_documents"],
        message: messages.documentsRequired,
      });
    }
  };
}
